import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { EMAIL_PATTERN, ngHelper } from '@cakeiteasy/web-utils';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AUTH_FORMS } from '../../constants';

@Component({
  standalone: false,
  selector: 'login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss']
})
export class LoginFormComponent implements OnChanges {
  @Input() error: string = '';
  @Input() hideFooter: boolean = false;
  @Input() resetPasswordRequired: boolean = false;
  @Output() onFormChange = new EventEmitter<string>();
  @Output() onSubmit = new EventEmitter<{ email: string, password: string }>();
  @Output() onResetPassword = new EventEmitter<{ email: string }>();

  public AUTH_FORMS = AUTH_FORMS;
  public userForm: FormGroup;
  public EMAIL_PATTERN = EMAIL_PATTERN;

  constructor(private _fb: FormBuilder,
              private _elRef: ElementRef) {
    this.userForm = this._fb.group({
      password: ['', [Validators.required]],
      email: ['', [Validators.required]]
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    ngHelper.ifChanged(changes, 'error', () => {
      setTimeout(() => {
        const resetPassword = this._elRef.nativeElement.querySelector('a[href="#reset-password"]');
        const registerAnAccount = this._elRef.nativeElement.querySelector('a[href="#register-an-account"]');

        if (resetPassword) {
          resetPassword.addEventListener('click', ($event) => {
            $event.preventDefault();
            this.onFormChange.emit(this.AUTH_FORMS.LOST_PASSWORD);
          });
        }

        if (registerAnAccount) {
          registerAnAccount.addEventListener('click', ($event) => {
            $event.preventDefault();
            this.onFormChange.emit(this.AUTH_FORMS.REGISTER);
          });
        }
      });
    });
  }

  public submit() {
    this.onSubmit.emit(this.userForm.value);
  }

  public recoverPassword() {
    this.onResetPassword.emit(this.userForm.value.email);
  }
}
